import { RecoilRoot } from 'recoil';
import { Main } from './components/Main';
import styled from 'styled-components';
import { FacebookLike } from './components/common/facebook'
import React from 'react';

const StyledApp = styled.div`
  background-image: url('img/hrt-nyg-bg.jpg');
  position: fixed;
  top:0;
  bottom:0;
  left:0;
  right:0;
  background-repeat:repeat;
  background-size: cover;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  overflow: auto;
`;

const StyledHeader = styled.div`
align-self: flex-end;
padding: 5px 0px;
position: absolute;
z-index: 10;
`;

const App = () => {
  return (
    <StyledApp>
      <RecoilRoot>
        <Header />
        <Main />
      </RecoilRoot>
    </StyledApp>
  );
}

const Header = () => {
  return (
    <StyledHeader>
      <FacebookLike href="https://goodthings.homeruntaiwan.com/" />
    </StyledHeader>
  )
};

export default App;
